import React, { useRef, useState } from "react";
import { Drawer, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SignatariosBaseTable from "@components/table-signatarios";
import ActionBar from "../../components/action-bar";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";
import { fetchSignatarios, fetchSignatariosEmpresa } from "../../store/assinatura";
import { createHashId } from "@util/signerId";

const SignatariosDrawer = ({ isOpen, onClose, empresaId, onAddSigner, signatariosPending }) => {
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const [activeTabKey, setActiveTabKey] = useState("1");

  const actionBarRef1 = useRef();
  const actionBarRef2 = useRef();

  const { signatarios, signatariosEmpresas, loading } = useSelector((state) => state.assinaturas);

  const handleTabChange = (key) => {
    setActiveTabKey(key);

    setTimeout(() => {
      const ref = key === "1" ? actionBarRef1 : actionBarRef2;
      ref.current?.focus();
    }, 50);
  };

  const handleDrawerOpen = () => {
    setTimeout(() => {
      const ref = activeTabKey === "1" ? actionBarRef1 : actionBarRef2;
      ref.current?.focus();
    }, 300);
  };

  const cadastradosTitle = () => <ActionBar ref={actionBarRef1} onSearch={(value) => dispatch(fetchSignatarios(value))} searchLoading={loading} searchFormatter="cpf" />;

  const empresasTitle = () => <ActionBar ref={actionBarRef2} onSearch={(value) => dispatch(fetchSignatariosEmpresa({ empresaId, search: value }))} searchLoading={loading} searchFormatter="cpf" />;

  const empresasData = signatariosEmpresas.map((s) => {
    const isCpf = s.documento && s.documento.length <= 11;
    return {
      id: createHashId(s),
      nome: s.nome.trim(),
      cpf: isCpf ? s.documento : "",
      email: s.email ?? "",
      registered: false,
      tipo: s.tipo,
    };
  });

  const pendingIds = signatariosPending.map((s) => s.id);

  return (
    <Drawer title={t("Signatários disponíveis")} width="65%" onClose={onClose} open={isOpen} afterOpenChange={(open) => open && handleDrawerOpen()}>
      <Tabs
        activeKey={activeTabKey}
        onChange={handleTabChange}
        items={[
          {
            key: "1",
            label: t("Signatários Cadastrados"),
            children: <SignatariosBaseTable dataSource={signatarios.map((s) => ({ ...s, registered: true }))} loading={loading} onClick={onAddSigner} itemsList={pendingIds} title={cadastradosTitle} />,
          },
          {
            key: "2",
            label: t("Signatários da Empresa"),
            children: <SignatariosBaseTable dataSource={empresasData} loading={loading} onClick={onAddSigner} itemsList={pendingIds} title={empresasTitle} />,
          },
        ]}
      />
    </Drawer>
  );
};

export default SignatariosDrawer;
